import { render, staticRenderFns } from "./PCMenu.vue?vue&type=template&id=8dabd61e&scoped=true&"
import script from "./PCMenu.vue?vue&type=script&lang=js&"
export * from "./PCMenu.vue?vue&type=script&lang=js&"
import style0 from "./PCMenu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PCMenu.vue?vue&type=style&index=1&id=8dabd61e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dabd61e",
  null
  
)

export default component.exports